import Failed from "./Failed";
export default Failed;
